import { useState } from 'react';
import { Outlet } from 'react-router-dom'
import ReportHeader from './report-header.jsx';
import "../../../styles/Auth/report.css";
const Report = () => {
    return (
        <div className='report-layout'>
            <div className='report-content'>
                <main className='report-main'>
                    <ReportHeader />
                </main>
                <div className='report-body'>
                    <Outlet />
                </div>
            </div>
        </div>
    );
};
  
export default Report;